import {createSlice} from '@reduxjs/toolkit';
import {REDUCERS_NAMES} from '../constants';

const initialState: {
  isLoggedIn: boolean,
} = {
  isLoggedIn: false,
};

export const LoginSlice = createSlice({
  name: REDUCERS_NAMES.LOGIN,
  initialState,
  reducers: {
    setIsLoggedIn: (state, action) => {
      state.isLoggedIn = action.payload;
    },
  },
});

export const {setIsLoggedIn} = LoginSlice.actions;

export default LoginSlice.reducer;
